function Scrolling() {
  // easing functions http://goo.gl/5HLl8
  Math.easeInOutQuad = function (t, b, c, d) {
    t /= d / 2;
    if (t < 1) {
      return c / 2 * t * t + b;
    }
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
  };

  Math.easeInCubic = function (t, b, c, d) {
    const tc = (t /= d) * t * t;
    return b + c * (tc);
  };

  Math.inOutQuintic = function (t, b, c, d) {
    const ts = (t /= d) * t;
    const tc = ts * t;
    return b + c * (6 * tc * ts + -15 * ts * ts + 10 * tc);
  };


  function scrollLeft(element, _scrollLeft, duration, callback) {
    function move(amount) {
      if (element) {
        element.scrollLeft = amount;
      } else {
        // because it's so fucking difficult to detect the scrolling element, just move them all
        document.documentElement.scrollLeft = amount;
        document.body.parentNode.scrollLeft = amount;
        document.body.scrollLeft = amount;
      }
    }
    function position() {
      let pos;
      if (element) {
        pos = element.scrollLeft;
      } else {
        pos = document.documentElement.scrollLeft || document.body.parentNode.scrollLeft || document.body.scrollLeft;
      }
      return pos;
    }
    const start = position();
    const change = _scrollLeft - start;
    let currentTime = 0;
    const increment = 20;
    duration = (typeof (duration) === 'undefined') ? 500 : duration;
    var animateScroll = function () {
      // increment the time
      currentTime += increment;
      // find the value with the quadratic in-out easing function
      const val = Math.easeInOutQuad(currentTime, start, change, duration);
      // move the document.body
      move(val);
      // do the animation unless its over
      if (currentTime <= duration) {
        requestAnimationFrame(animateScroll);
      } else {
        move(_scrollLeft);
        if (callback && typeof (callback) === 'function') {
          // the animation is done so lets callback
          callback();
        }
      }
    };
    animateScroll();
  }


  function scrollTop(element, _scrollTop, duration, callback) {
    function move(amount) {
      if (element) {
        element.scrollTop = amount;
      } else {
        // because it's so fucking difficult to detect the scrolling element, just move them all
        document.documentElement.scrollTop = amount;
        document.body.parentNode.scrollTop = amount;
        document.body.scrollTop = amount;
      }
    }
    function position() {
      let pos;
      if (element) {
        pos = element.scrollTop;
      } else {
        pos = document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop;
      }
      return pos;
    }
    const start = position();
    const change = _scrollTop - start;
    let currentTime = 0;
    const increment = 20;
    duration = (typeof (duration) === 'undefined') ? 500 : duration;
    var animateScroll = function () {
      // increment the time
      currentTime += increment;
      // find the value with the quadratic in-out easing function
      const val = Math.easeInOutQuad(currentTime, start, change, duration);
      // move the document.body
      move(val);
      // do the animation unless its over
      if (currentTime <= duration) {
        requestAnimationFrame(animateScroll);
      } else {
        move(_scrollTop);
        if (callback && typeof (callback) === 'function') {
          // the animation is done so lets callback
          callback();
        }
      }
    };
    animateScroll();
  }

  this.scrollTop = scrollTop;
  this.scrollLeft = scrollLeft;
}


window.SCROLLING = new Scrolling();
